import axiosInstance from "./client";
import {
  TWalletData,
  TWalletAddData,
  TWalletEditData,
  TWalletDetailData,
} from "~/types";
import { convertCurrencyStringToNumber } from "~/utils";

const addWallet = async (data: TWalletAddData) => {
  let walletData: any;
  walletData = {
    walletName: data.name,
    currencyID: data.currencyId,
    excludeFromTotal: data.excludeFromTotal,
    walletType: data.type,
  };

  if (data.type === "Basic") {
    if (data.initialBalance !== "0") {
      walletData.initialBalance = convertCurrencyStringToNumber(
        data.initialBalance
      );
    }
  } else if (data.type === "Goal") {
    walletData.goalValue = convertCurrencyStringToNumber(data.goalValue);
    walletData.endingDate = data.endingDate;
    walletData.enableNotification = data.enableNotify;
    if (data.startingAmount !== "0") {
      walletData.startingAmount = convertCurrencyStringToNumber(
        data.startingAmount
      );
    }
  }

  const response = await axiosInstance.post(`/wallet/create`, walletData);
  return response;
};

const editWallet = async (data: TWalletEditData) => {
  const response = await axiosInstance.put(`/wallet/update`, {
    walletInforID: data.id,
    walletName: data.name,
    currencyID: data.currencyId,
    excludeFromTotal: data.excludeFromTotal,
    walletType: data.type,
    endingDate: data.endingDate,
    enableNotification: data.enableNotify,
    initialBalance: convertCurrencyStringToNumber(data.initialBalance),
    goalValue: convertCurrencyStringToNumber(data.goalValue),
    startingAmount: convertCurrencyStringToNumber(data.startingAmount),
  });
  return response;
};

const getCurrencyUnits = async () => {
  const response = await axiosInstance.get(`/currency/all`);
  return response.data;
};

const getWalletList = async (): Promise<TWalletData[]> => {
  let ret = [];
  const response = await axiosInstance.get(`/wallet/all`);
  ret = response.data?.map((walletItem: any) => ({
    id: walletItem?.walletInforID,
    name: walletItem?.walletName,
    type: walletItem?.walletType,
    currencyId: walletItem?.currencyID,
    initialBalance: walletItem?.initialBalance,
    total: walletItem?.total,
  }));
  return ret;
};

const getWalletInfo = async (walletId: string): Promise<TWalletDetailData> => {
  const response = await axiosInstance.get(
    `/wallet/details?walletInforID=${walletId}`
  );

  const wallet = response.data;
  return {
    id: wallet.walletInforID,
    name: wallet.walletName,
    type: wallet.walletType,
    currencyId: wallet.currencyID,
    excludeFromTotal: wallet.excludeFromTotal,
    initialBalance: wallet.initialBalance,
    goalValue: wallet.goalValue,
    startingAmount: wallet.startingAmount,
    endingDate: wallet.endingDate,
    enableNotify: wallet.enableNotification,
    users: wallet.users,
    total: wallet.total,
  };
};

const shareWallet = async (shareWalletData: {
  sharedUsername: string;
  walletInforID: string;
}) => {
  const response = await axiosInstance.post(`/wallet/share`, shareWalletData);
  return response;
};

const unShareWallet = async (unshareWalletData: {
  unsharedUsername: string;
  walletInforID: string;
}) => {
  const response = await axiosInstance.delete(`/wallet/unshare`, {
    data: unshareWalletData,
  });
  return response;
};

const deleteWallet = async (walletId: string) => {
  const response = await axiosInstance.delete(
    `/wallet/delete?walletInforID=${walletId}`
  );
  return response;
};

export {
  addWallet,
  editWallet,
  getCurrencyUnits,
  getWalletList,
  shareWallet,
  unShareWallet,
  getWalletInfo,
  deleteWallet,
};
